import _objectSpread from "@babel/runtime/helpers/objectSpread2";
var _Toaster;
/**
 * This component is just a copy of the spa/layout.tsx component.
 * The only difference is that it adds the CentralizedUserSessionProvider and other useful providers and global components.
 * This was created to avoid breaking changes in case something went wrong with the centralized user session provider.
 */
import 'intersection-observer';
import { useEffect } from 'react';
import { AuthCentralizedProvider } from '@crehana/auth';
import { UIThemeProvider as CompassUIThemeProvider } from '@crehana/compass.ui';
import { Toaster } from '@crehana/compass.ui/toaster';
import { install } from '@crehana/devtools';
import { CrehanaLayout } from "../Layouts";
import { LoadIntercom } from "./components/load-intercom";
import { useInitSentry } from "./hooks/use-init-sentry";
import { cookieValues } from "./utils";

/**
 * Expose the microfrontend name to the window object to make it easy to find the microfrontend of the current page
 */
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
if (typeof window !== 'undefined') {
  // @ts-expect-error the bundler will make sure that this exists
  window.CREHANA_MICROFRONTEND_NAME = process.env.CREHANA_MICROFRONTEND_NAME;
}
export var SPALayout = function SPALayout(_ref) {
  var children = _ref.children,
    initialApolloState = _ref.initialApolloState,
    countryCode = _ref.countryCode,
    pageKey = _ref.pageKey,
    i18nProviderProps = _ref.i18nProviderProps,
    isErrorPage = _ref.isErrorPage,
    amplitudeApiKey = _ref.amplitudeApiKey,
    renderCookiesBanner = _ref.renderCookiesBanner,
    sentryInstance = _ref.sentryInstance,
    organizationSlug = _ref.organizationSlug,
    intercomConfig = _ref.intercomConfig;
  useInitSentry({
    sentryInstance: sentryInstance
  });
  useEffect(function () {
    install();
  }, []);
  return /*#__PURE__*/_jsx(CrehanaLayout, {
    initialApolloState: initialApolloState,
    countryCode: cookieValues.country || countryCode,
    pageKey: pageKey,
    i18nProviderProps: _objectSpread({
      languageCode: cookieValues.language
    }, i18nProviderProps),
    renderCookiesBanner: renderCookiesBanner,
    isErrorPage: isErrorPage,
    amplitudeApiKey: amplitudeApiKey,
    sentryInstance: sentryInstance,
    children: /*#__PURE__*/_jsxs(CompassUIThemeProvider, {
      children: [/*#__PURE__*/_jsxs(AuthCentralizedProvider, {
        organizationSlug: organizationSlug,
        children: [children, /*#__PURE__*/_jsx(LoadIntercom, {
          config: intercomConfig
        })]
      }), _Toaster || (_Toaster = /*#__PURE__*/_jsx(Toaster, {}))]
    })
  });
};